import React from 'react';
import classNames from 'classnames';

import { ComponentColor } from './types';

export const Tooltip = ({
    className,
    children,
    text,
    color = ComponentColor.Neutral,
    orientation = 'top',
    hide
}: TooltipProps): React.JSX.Element => {
    const tooltipClasses = classNames(
        'tooltip',
        color === ComponentColor.Accent ? 'tooltip-accent' : '',
        color === ComponentColor.Error ? 'tooltip-error' : '',
        color === ComponentColor.Ghost ? 'tooltip-ghost' : '',
        color === ComponentColor.Info ? 'tooltip-info' : '',
        color === ComponentColor.Neutral ? 'tooltip-neutral' : '',
        color === ComponentColor.Primary ? 'tooltip-primary' : '',
        color === ComponentColor.Secondary ? 'tooltip-secondary' : '',
        color === ComponentColor.Success ? 'tooltip-success' : '',
        color === ComponentColor.Warning ? 'tooltip-warning' : '',
        orientation === 'top' ? 'tooltip-top' : '',
        orientation === 'bottom' ? 'tooltip-bottom' : '',
        orientation === 'left' ? 'tooltip-left' : '',
        orientation === 'right' ? 'tooltip-right' : '',
        className
    );

    return (
        <div className={hide ? '' : tooltipClasses} data-tip={text}>
            {children}
        </div>
    );
};

interface TooltipProps {
    className?: string;
    children: React.ReactNode;
    text: string;
    color?: ComponentColor;
    orientation?: TooltipOrientation;
    hide?: boolean;
}

type TooltipOrientation = 'top' | 'right' | 'bottom' | 'left';

export default Tooltip;
